import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBandaid = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.49423 3.97583L20.1051 14.5875C20.4735 14.9484 20.7667 15.3788 20.9677 15.8538C21.1687 16.3287 21.2736 16.8388 21.2762 17.3545C21.2788 17.8703 21.1792 18.3814 20.9831 18.8584C20.7869 19.3354 20.4982 19.7687 20.1335 20.1334C19.7688 20.4981 19.3354 20.7869 18.8585 20.983C18.3815 21.1792 17.8703 21.2788 17.3546 21.2761C16.8389 21.2735 16.3288 21.1686 15.8538 20.9676C15.3789 20.7666 14.9485 20.4734 14.5876 20.105L3.97589 9.49416C3.24412 8.76239 2.83301 7.76989 2.83301 6.735C2.83301 5.70011 3.24412 4.70761 3.97589 3.97583C4.70767 3.24405 5.70017 2.83295 6.73506 2.83295C7.76995 2.83295 8.76245 3.24405 9.49423 3.97583V3.97583Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.79639 13.3142L13.3142 7.79642L16.2852 10.7674L10.7674 16.2852L7.79639 13.3142Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1959 16.4517C15.1669 16.4226 15.1324 16.3995 15.0944 16.3837C15.0565 16.368 15.0158 16.3599 14.9747 16.3599C14.9336 16.3599 14.8929 16.368 14.8549 16.3837C14.8169 16.3995 14.7824 16.4226 14.7534 16.4517"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1958 16.8933C15.2543 16.8347 15.2872 16.7553 15.2872 16.6725C15.2872 16.5897 15.2543 16.5103 15.1958 16.4517"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 16.8933C14.8088 16.9517 14.8884 16.9845 14.9713 16.9845C15.0541 16.9845 15.1337 16.9517 15.1925 16.8933"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7501 16.4517C14.6916 16.5103 14.6587 16.5897 14.6587 16.6725C14.6587 16.7553 14.6916 16.8347 14.7501 16.8933"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5908 16.4517C18.5619 16.4226 18.5275 16.3995 18.4896 16.3838C18.4517 16.368 18.411 16.3599 18.37 16.3599C18.329 16.3599 18.2883 16.368 18.2504 16.3838C18.2125 16.3995 18.1781 16.4226 18.1492 16.4517"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5908 16.8933C18.6199 16.8644 18.643 16.83 18.6587 16.7921C18.6745 16.7542 18.6826 16.7135 18.6826 16.6725C18.6826 16.6315 18.6745 16.5908 18.6587 16.5529C18.643 16.515 18.6199 16.4806 18.5908 16.4517"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1492 16.8933C18.2078 16.9519 18.2872 16.9847 18.37 16.9847C18.4528 16.9847 18.5322 16.9519 18.5908 16.8933"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1491 16.4517C18.12 16.4806 18.097 16.515 18.0812 16.5529C18.0655 16.5908 18.0574 16.6315 18.0574 16.6725C18.0574 16.7135 18.0655 16.7542 18.0812 16.7921C18.097 16.83 18.12 16.8644 18.1491 16.8933"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.85744 7.11333C5.79884 7.05481 5.71942 7.02194 5.6366 7.02194C5.55379 7.02194 5.47437 7.05481 5.41577 7.11333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.85767 7.55583C5.88677 7.5268 5.90986 7.49232 5.92561 7.45435C5.94137 7.41639 5.94947 7.37569 5.94947 7.33458C5.94947 7.29348 5.94137 7.25278 5.92561 7.21481C5.90986 7.17684 5.88677 7.14236 5.85767 7.11333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.41675 7.55583C5.47534 7.61435 5.55477 7.64722 5.63758 7.64722C5.72039 7.64722 5.79982 7.61435 5.85841 7.55583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.41676 7.11333C5.38766 7.14236 5.36457 7.17684 5.34881 7.21481C5.33306 7.25278 5.32495 7.29348 5.32495 7.33458C5.32495 7.37569 5.33306 7.41639 5.34881 7.45435C5.36457 7.49232 5.38766 7.5268 5.41676 7.55583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25002 7.11333C9.19142 7.05481 9.112 7.02194 9.02918 7.02194C8.94637 7.02194 8.86694 7.05481 8.80835 7.11333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 7.55583C9.30837 7.49699 9.34112 7.41746 9.34112 7.33458C9.34112 7.2517 9.30837 7.17217 9.25 7.11333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.81177 7.55583C8.87036 7.61435 8.94979 7.64722 9.0326 7.64722C9.11541 7.64722 9.19484 7.61435 9.25343 7.55583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.81178 7.11333C8.78268 7.14236 8.75959 7.17684 8.74383 7.21481C8.72808 7.25278 8.71997 7.29348 8.71997 7.33458C8.71997 7.37569 8.72808 7.41639 8.74383 7.45435C8.75959 7.49232 8.78268 7.5268 8.81178 7.55583"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBandaid.displayName = 'SvgBandaid';
export default SvgBandaid;
